import { render, staticRenderFns } from "./ArticlesCategories.vue?vue&type=template&id=e57b9464"
import script from "./ArticlesCategories.vue?vue&type=script&lang=js"
export * from "./ArticlesCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports